export function shouldProcessImage(file:File){
    if(file.name.match(/\.png|jpe?g/i))
       return file.size > 200_000;
    return false; 
}

function bestSize(img:HTMLImageElement, {maxWidth, maxHeight}:{maxWidth: number, maxHeight: number}){
    let newWidth = img.naturalWidth;
    let newHeight = img.naturalHeight;
    let wr = newWidth / newHeight;
    let hr = newHeight / newWidth;

    if (newWidth > maxWidth) {
        newWidth = maxWidth;
        newHeight = hr * newWidth;
    }

    if (newHeight > maxHeight) {
        newHeight = maxHeight;
        newWidth = wr * newHeight;
    }

    return [newWidth, newHeight];
}

function createCanvas(width:number, height:number){
    var canvas = document.createElement('canvas') as HTMLCanvasElement;
    canvas.width = width;
    canvas.height = height
    return canvas;
}

export async function shrinkImage(file:File):Promise<Blob>{
    return new Promise((ok, fail)=>{
        function onLoad(){
            const img = new Image();
            img.src = reader.result as string;
            img.onerror = fail
            img.onload = async () => {
                const [width, height] = bestSize(img, {maxWidth: 1024, maxHeight: 1024});
                const canvas = createCanvas(width, height);
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0, width, height)
                const blob = await new Promise<Blob>(resolve => canvas.toBlob(resolve, "image/jpeg", 0.8))
                ok(blob);
            }
        }

        const reader = new FileReader();
        reader.onload = onLoad;
        reader.onerror = fail
        reader.readAsDataURL(file);
    });
}